/**
 * Map UI language names to dayjs locale codes and set dayjs locale globally.
 * Import this and call setDayjsLocale(language) when user language changes.
 */
import dayjs from "dayjs";
import advancedFormat from "dayjs/plugin/advancedFormat";
import "dayjs/locale/sv";
import "dayjs/locale/ka";
import "dayjs/locale/lv";
import "dayjs/locale/ru";
import "dayjs/locale/uk";

dayjs.extend(advancedFormat);

const LANGUAGE_TO_DAYJS = {
  English: "en",
  Swedish: "sv",
  Georgian: "ka",
  Latvian: "lv",
  Russian: "ru",
  Ukrainian: "uk",
};

/**
 * Set dayjs global locale from UI language name.
 * @param {string} languageName - e.g. user.languages.ui ("English", "Swedish", ...)
 */
export function setDayjsLocale(languageName) {
  const code = LANGUAGE_TO_DAYJS[languageName?.trim()] || "en";
  dayjs.locale(code);
}
